module.exports = __webpack_public_path__ + "static/media/cloakroom.6ce173be.svg";